export const updateKbUser = `mutation($model : UpdateKbUserRequest!){
  updateKbUser(input : $model) 
}`
